// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://hospitalquee.onrender.com/",
});

export default axiosInstance;

// export const weburl = "https://backend-2o7f.onrender.com/";
export const weburl = "https://hospitalquee.onrender.com/";

export const shopurl = "https://hospitalquee.spacedeco.in/";
export const mainurl = "https://hospitalquee.spacedeco.in/";
export const fronturl = "https://hospitalquee.spacedeco.in/";
export const socketURL = "https://hospitalquee.onrender.com/";

export const keyLogin = process.env.REACT_APP_LOGIN_KEY;